import React from "react";

import { Link } from "react-router-dom";
import { dataListsType } from "./featured-posts";
import LazyImage from "./lazyImage";

type Props = {
  props: dataListsType[];
};

const CardLeftRight: React.FC<Props> = ({ props }) => {
  return (
    <>
      {props.map((item, key) => {
        return (
          <Link
            rel="stylesheet"
            target="_top"
            to={{
              pathname: `/detailspage`,
              search: `?id=${item.id}&${item.category}/${item.urlinform}/`,
            }}
            key={key}
          >
            <div className="w-full max-h-[200px] flex p-3 rounded-lg bg-white overflow-hidden shadow-lg hover:shadow-xl transform transition-transform duration-500 ease-in-out hover:-translate-y-2 cursor-pointer">
              <div className="w-[35%] rounded-lg overflow-hidden">
                <LazyImage
                  src={item.images[0]}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-[65%] flex items-center pl-7">
                <div className="flex flex-col">
                  <span className="text-sm font-bold text-[#5b68d3] my-1.5">
                    {item.category}
                  </span>
                  <span className="line-clamp-2">
                    <b className="text-lg font-bold">{item.title}</b>
                    <i className="text-opacity-0 bg-transparent text-[#c84e47] text-[6px]">
                      | The Asia Wander
                    </i>
                  </span>

                  <span className="w-full mt-2 text-xs font-medium text-[#363f4d] line-clamp-3">
                    {item.description}
                  </span>
                </div>
              </div>
            </div>
          </Link>
        );
      })}
    </>
  );
};

export default CardLeftRight;
